import { render } from "./TemporaryWorker.vue?vue&type=template&id=acad5acc&scoped=true"
import script from "./TemporaryWorker.vue?vue&type=script&lang=js"
export * from "./TemporaryWorker.vue?vue&type=script&lang=js"

import "./TemporaryWorker.vue?vue&type=style&index=0&id=acad5acc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acad5acc"]])

export default __exports__